import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * `/vetting-requests/{id}` is not a screen — `/vetting/$vettingId` is
 * (../routes/_app.vetting.$vettingId.tsx).
 *
 * It exists because the WhatsApp deep link a vetting review notification
 * carries is built the way the domain names the resource, `vetting-requests`,
 * not the way this app's own nav does (US-00-004.17/.18, US-01-004.9,
 * TC-US-00-004-8-3). A recipient with the app installed follows the app link;
 * a recipient without it lands on the equivalent RESPONSIVE WEB PAGE, and that
 * page has to exist at the URL the message actually sends rather than at the
 * one this app happens to call the same screen internally — the alternative is
 * the dead end TC-US-00-004-8-3 found: "Page not found" for every device that
 * does not have the app.
 *
 * A redirect rather than a second copy of the screen, so there is exactly one
 * vetting-detail implementation to keep US-00-004.10/.11/.12 true of.
 */
export const Route = createFileRoute("/_app/vetting-requests/$vettingId")({
	beforeLoad: ({ params }) => {
		// eslint-disable-next-line @typescript-eslint/only-throw-error
		throw redirect({
			to: "/vetting/$vettingId",
			params: { vettingId: params.vettingId },
			replace: true,
		})
	},
})
